/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Namerequired1Inputs */

const zh_auth_namerequired1 = /** @type {(inputs: Auth_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入姓名`)
};

const en_auth_namerequired1 = /** @type {(inputs: Auth_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required`)
};

const es_auth_namerequired1 = /** @type {(inputs: Auth_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre es obligatorio`)
};

/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Auth_Namerequired1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_namerequired1 = /** @type {((inputs?: Auth_Namerequired1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Namerequired1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_namerequired1(inputs)
	if (locale === "en") return en_auth_namerequired1(inputs)
	return es_auth_namerequired1(inputs)
});
export { auth_namerequired1 as "auth_nameRequired" }